// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Encounter view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...EncounterRender }`, [EncounterRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const EncounterRenderFragment = graphql(`
  fragment EncounterRender on Encounter @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    status
    statusHistory {
      status
      period {
        start
        end
      }
    }
    class {
      system
      code
      display
    }
    classHistory {
      class {
        system
        code
        display
      }
      period {
        start
        end
      }
    }
    type {
      text
      coding {
        system
        code
        display
      }
    }
    serviceType {
      text
      coding {
        system
        code
        display
      }
    }
    priority {
      text
      coding {
        system
        code
        display
      }
    }
    subject {
      reference
      type
      display
    }
    episodeOfCare {
      reference
      type
      display
    }
    basedOn {
      reference
      type
      display
    }
    participant {
      type {
        text
        coding {
          system
          code
          display
        }
      }
      period {
        start
        end
      }
      individual {
        reference
        type
        display
      }
    }
    appointment {
      reference
      type
      display
    }
    period {
      start
      end
    }
    length {
      value
      comparator
      unit
      system
      code
    }
    reasonCode {
      text
      coding {
        system
        code
        display
      }
    }
    reasonReference {
      reference
      type
      display
    }
    diagnosis {
      condition {
        reference
        type
        display
      }
      use {
        text
        coding {
          system
          code
          display
        }
      }
      rank
    }
    account {
      reference
      type
      display
    }
    hospitalization {
      preAdmissionIdentifier {
        use
        system
        value
      }
      origin {
        reference
        type
        display
      }
      admitSource {
        text
        coding {
          system
          code
          display
        }
      }
      reAdmission {
        text
        coding {
          system
          code
          display
        }
      }
      dietPreference {
        text
        coding {
          system
          code
          display
        }
      }
      specialCourtesy {
        text
        coding {
          system
          code
          display
        }
      }
      specialArrangement {
        text
        coding {
          system
          code
          display
        }
      }
      destination {
        reference
        type
        display
      }
      dischargeDisposition {
        text
        coding {
          system
          code
          display
        }
      }
    }
    location {
      location {
        reference
        type
        display
      }
      status
      physicalType {
        text
        coding {
          system
          code
          display
        }
      }
      period {
        start
        end
      }
    }
    serviceProvider {
      reference
      type
      display
    }
    partOf {
      reference
      type
      display
    }
  }
`);
